import React from 'react';

import {components, OptionProps} from 'react-select';
import styled from 'styled-components';

import {ProductGroupIcon} from 'components/common/ProductGroupIcon';

import {colors, font} from 'theme';

const Label = styled.div<{isSelected?: boolean}>`
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: ${(p) => (p.isSelected ? colors.white : colors.textGrey1)};
`;
const Wrapper = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0;
    margin: 0;
`;

export const GtinOptionComponent = (props: OptionProps<any, false>) => (
    <components.Option {...props}>
        <Wrapper>
            <ProductGroupIcon
                width={10}
                style={{marginBottom: 0}}
                value={props.data.meta.productGroupCode}
            />
            <Label isSelected={props.isSelected}>{props.data.label}</Label>-
            <Label isSelected={props.isSelected}>{props.data.meta.productName}</Label>-
            <Label isSelected={props.isSelected}>{props.data.meta.type}</Label>
        </Wrapper>
    </components.Option>
);
